module.exports = __webpack_public_path__ + "img/9ecebdef4fcb5ebedd7fc854d3995419-website-france-live-dark.9ecebdef.svg";